module.exports = __webpack_public_path__ + "img/3-1.bd05d9da.png";